module.exports = __webpack_public_path__ + "media/images/icons/tutoring-package-2-33cb266e3a0eda7795bc455f00bd94c0.svg";